const ViolenceType = {
    options: [
        {value: "PHYSICAL", label: "Física"},
        {value: "PSYCHOLOGICAL", label: "Psicológica"},
        {value: "MORAL", label: "Moral"},
        {value: "SEXUAL", label: "Sexual"},
        {value: "ASSET", label: "Patrimonial"},
        {value: "VICARIOUS", label: "Vicária"},
        {value: "OTHER", label: "Outros"}
    ],

    toOption: (value) => {
        if (!value) return [];

        return value.map(v => ViolenceType.options.find(option => option.value === v))
    },

    optionsToView: (value) => {
        if (!value) return [];

        return value.map(v => v.label).sort().join(", ")
    },

    toView: (value) => {
        if (!value) return "";

        return value.map(v => ViolenceType.options.find(option => option.value === v)?.label).join(", ")
    }
};

export default ViolenceType;